import { Icon } from '@iconify/react';
import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { StyledButton } from '../../../../components/StyledButton';
import { StyledInput } from '../../../../components/StyledInput';
import {
  GetAnticipationResult,
  useAntecipacao,
} from '../../../../services/hooks/useAntecipacao';
import { NewFormatValue } from '../../../../utils/NewFormatValue';
import { checkLengthToMaskCpfOrCnpj } from '../../../../utils/checkLengthToMaskCpfOrCnpj';
import { AggregatedValue, initialValues } from '../../pages/Antecipacao';
import {
  ByEstablishmentValuesWrapper,
  ContentBody,
  ContentFooter,
  ContentHeader,
  PainelValuesContainer,
  StatusLabel,
  TotalValuesWrapper,
} from './styles';
import { Loading } from '../../../../components/Loading';
import { BeatLoader } from 'react-spinners';

interface AnticipationModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  anticipationList: GetAnticipationResult[];
  checkedValues: AggregatedValue;
  dtAnticipation: string | undefined;
  user: {
    docto: string;
    email: string;
  };
}

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',

    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',

    maxHeight: '80vh',

    borderRadius: '12px',
  },
};

type InputsPerDoc = Array<{ [key: string]: AggregatedValue }>;

export enum AnticipationRoleStatus {
  pendingRequest = 'Aguardando Solicitação',
  anticipationRequested = 'Antecipação Solicitada',
  anticipationFailed = 'Falha na Solicitação',
  processing = 'Processando',
}

interface IListStatusRolePerDoc {
  [key: string]: AnticipationRoleStatus;
}

export function AnticipationModal({
  isOpen,
  onRequestClose,
  anticipationList,
  checkedValues,
  dtAnticipation,
  user,
}: AnticipationModalProps) {
  const { applyAnticipationValue } = useAntecipacao();
  const [isLoading, setIsLoading] = useState(false);
  const [inputsPerDoc, setInputsPerDoc] = useState<InputsPerDoc>([{}]);

  const [listQueriesFailed, setListQueriesFailed] = useState<any[]>([]);

  const [needDisableButton, setNeedDisableButton] = useState<boolean>(false);

  const [listStatusRolePerDoc, setListStatusRolePerDoc] =
    useState<IListStatusRolePerDoc>({});

  const handleToResetListStatusRolePerDoc = () => {
    const newStatus = inputsPerDoc.reduce((acc: any, doc: Object) => {
      if (Object.values(doc)[0]?.estabDocto) {
        const newObjectStatus = {
          [Object.values(doc)[0]?.estabDocto as string]:
            AnticipationRoleStatus.pendingRequest,
        };
        return { ...acc, ...newObjectStatus };
      } else {
        return acc;
      }
    }, {});

    setListStatusRolePerDoc(newStatus);
  };
  useEffect(() => {
    handleToResetListStatusRolePerDoc();
  }, [inputsPerDoc]);

  useEffect(() => {
    const establishmentsAvailable = new Set();
    anticipationList.forEach((loja) =>
      establishmentsAvailable.add(loja.estabDocto)
    );
    const arrayDocsEstablishmentsAvailable = Array.from(
      establishmentsAvailable
    );

    const aggregateValue = arrayDocsEstablishmentsAvailable.map((doc: any) => {
      const anticipationListFilteredByDoc = anticipationList.filter(
        (each) => each?.estabDocto === doc
      );

      let keyValue: string = '';
      let listItems: { idOrdemRepasse: string }[] = [];
      const object = anticipationListFilteredByDoc.reduce(
        (acc: AggregatedValue, obj: any, i) => {
          keyValue = `${checkLengthToMaskCpfOrCnpj(obj.estabDocto)} - ${
            obj.estabFantasia
          }`;

          listItems.push({ idOrdemRepasse: obj?.idOrdemRepasse });

          const dataObject = {
            estabFantasia: obj?.estabFantasia,
            estabDocto: obj?.estabDocto,
            listItemsIdOrdemRepasse: listItems,
            vlBruto: (acc.vlBruto += obj?.vlParcela),
            vlTxAdm: (acc.vlTxAdm += obj?.vlTxAdm),
            vlTxAntSimulado: (acc.vlTxAntSimulado += obj?.vlTxAntSimulado),
            vlPos: (acc.vlPos += obj.vlLocacao),
            vlLiquido: (acc.vlLiquido += obj?.vlAberto - obj?.vlTxAntSimulado),
          } as AggregatedValue;

          return dataObject;
        },
        { ...initialValues }
      );

      const objectToReturn = { [keyValue]: object };

      return objectToReturn;
    });

    setInputsPerDoc(aggregateValue);
  }, [anticipationList]);

  async function handleSubmitModal() {
    setIsLoading(true);
    let listQueriesFailed: any[] = [];

    for (let eachDoc of inputsPerDoc) {
      const weObjectEachDoc = Object.values(eachDoc)?.[0];
      setListStatusRolePerDoc((prev) => ({
        ...prev,
        [weObjectEachDoc?.estabDocto as string]:
          AnticipationRoleStatus.processing,
      }));
      try {
        if (weObjectEachDoc) {
          const bodyToQuery = {
            docto: weObjectEachDoc?.estabDocto || '',
            dtAntecipacao: dtAnticipation || '',
            emailSolicitante: user?.email || '',
            itens: weObjectEachDoc?.listItemsIdOrdemRepasse || [],
          };
          console.log('🚀 ~ handleSubmitModal ~ bodyToQuery:', bodyToQuery);

          const response = await applyAnticipationValue(bodyToQuery);
          console.log('🚀 ~ handleSubmitModal ~ response:', response);

          if (response?.status === 200 || response?.status === 201) {
            setListStatusRolePerDoc((prev) => ({
              ...prev,
              [weObjectEachDoc?.estabDocto as string]:
                AnticipationRoleStatus.anticipationRequested,
            }));
          } else {
            throw new Error(
              'Erro ao solicitar antecipação' +
                ' - ' +
                JSON.stringify(response?.data)
            );
          }
        }
      } catch (error: any) {
        console.log("🚀 ~ catch handleSubmitModal ~ error:", {...error})
        listQueriesFailed.push({
          establishment: weObjectEachDoc?.estabFantasia,
          doc: weObjectEachDoc?.estabDocto,
          error: error?.response?.data?.message || error?.message,
        });

        setListStatusRolePerDoc((prev) => ({
          ...prev,
          [weObjectEachDoc?.estabDocto as string]:
            AnticipationRoleStatus.anticipationFailed,
        }));
      }
    }

    setIsLoading(false);
    setListQueriesFailed(listQueriesFailed);
    setNeedDisableButton(true);
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={() => {
          onRequestClose();
        }}
        contentLabel="Example Modal"
        style={customStyles}
        shouldCloseOnOverlayClick={false}
      >
        <ContentHeader>
          <h2>Fazer Antecipação</h2>
        </ContentHeader>
        <ContentBody>
          {isLoading && <Loading />}
          <PainelValuesContainer>
            <h3>Total Geral</h3>
            <TotalValuesWrapper>
              <StyledInput
                value={`Valor bruto: ${NewFormatValue(checkedValues.vlBruto)}`}
                disabled={true}
              />
              <StyledInput
                value={`Valor taxa adm: ${NewFormatValue(
                  checkedValues.vlTxAdm
                )}`}
                disabled={true}
              />
              <StyledInput
                value={`Valor taxa antecipação: ${NewFormatValue(
                  checkedValues.vlTxAntSimulado
                )}`}
                disabled={true}
              />

              <StyledInput
                value={`Valor aluguel POS: ${NewFormatValue(
                  checkedValues.vlPos
                )}`}
                disabled={true}
              />
              <StyledInput
                value={`Valor liquido: ${NewFormatValue(
                  checkedValues.vlLiquido
                )}`}
                disabled={true}
              />
              {inputsPerDoc?.length <= 1 && (
                <StatusLabel
                  role={
                    listStatusRolePerDoc[checkedValues.estabDocto as string]
                  }
                  labelBefore={
                    listQueriesFailed.find(
                      (obj) => obj.doc === checkedValues.estabDocto
                    )?.error
                  }
                >
                  {listStatusRolePerDoc[checkedValues.estabDocto as string] !==
                    'Processando' &&
                    listStatusRolePerDoc[checkedValues.estabDocto as string]}
                  {listStatusRolePerDoc[checkedValues.estabDocto as string] ===
                    'Processando' && <BeatLoader color="gray" />}
                </StatusLabel>
              )}
            </TotalValuesWrapper>

            {inputsPerDoc?.length > 1 &&
              inputsPerDoc.map((input) =>
                Object.keys(input).map((key) => (
                  <ByEstablishmentValuesWrapper key={key}>
                    <h3>{key}</h3>
                    <TotalValuesWrapper>
                      <StyledInput
                        value={`Valor bruto: ${NewFormatValue(
                          input[key].vlBruto
                        )}`}
                        disabled={true}
                      />
                      <StyledInput
                        value={`Valor taxa adm: ${NewFormatValue(
                          input[key].vlTxAdm
                        )}`}
                        disabled={true}
                      />
                      <StyledInput
                        value={`Valor taxa antecipação: ${NewFormatValue(
                          input[key].vlTxAntSimulado
                        )}`}
                        disabled={true}
                      />
                      <StyledInput
                        value={`Valor aluguel POS: ${NewFormatValue(
                          input[key].vlPos
                        )}`}
                        disabled={true}
                      />
                      <StyledInput
                        value={`Valor liquido: ${NewFormatValue(
                          input[key].vlLiquido
                        )}`}
                        disabled={true}
                      />
                      <StatusLabel
                        role={
                          listStatusRolePerDoc[input[key].estabDocto as string]
                        }
                        labelBefore={
                          listQueriesFailed.find(
                            (obj) => obj.doc === input[key].estabDocto
                          )?.error
                        }
                      >
                        {listStatusRolePerDoc[
                          input[key].estabDocto as string
                        ] !== AnticipationRoleStatus.processing &&
                          listStatusRolePerDoc[input[key].estabDocto as string]}
                        {listStatusRolePerDoc[
                          input[key].estabDocto as string
                        ] === AnticipationRoleStatus.processing && (
                          <BeatLoader color="gray" />
                        )}
                      </StatusLabel>
                    </TotalValuesWrapper>
                  </ByEstablishmentValuesWrapper>
                ))
              )}
          </PainelValuesContainer>

          <ContentFooter>
            <StyledButton
              icon={
                <Icon icon="iconamoon:arrow-left-6-circle-fill" width={20} />
              }
              iconPosition="left"
              text={needDisableButton ? 'FECHAR' : 'Cancelar'}
              color="#595044"
              onClick={() => {
                setNeedDisableButton(false);
                handleToResetListStatusRolePerDoc();
                onRequestClose();
              }}
            />

            <StyledButton
              icon={
                <Icon icon="iconamoon:arrow-right-6-circle-fill" width={20} />
              }
              iconPosition="right"
              text="Solicitar Antecipação"
              onClick={handleSubmitModal}
              disabled={
                !checkedValues.vlBruto || needDisableButton ? true : false
              }
            />
          </ContentFooter>
        </ContentBody>
      </Modal>
    </>
  );
}
